// {data.type === "producer" && (
//     <Pill className={"text-[#EFD948] ml-[-4px] mr-1"}>P</Pill>
//   )}
//   {data.type === "consumer" && (
//     <Pill className={"text-[#96EF48] ml-[-4px] mr-1"}>C</Pill>
//   )}
//   {data.type === "producer / consumer" && (
//     <>
//       <Pill className={"text-[#EFD948] ml-[-4px] mr-1"}>P</Pill>
//       <Pill className={"text-[#96EF48] mr-2"}>C</Pill>
//     </>
//   )}
import { cn } from "@/lib/utils";

const Pill = ({ children, className }) => {
  return (
    <div
      className={cn(
        "bg-[#2B2E38] text-white text-xs px-2 py-1 rounded-full",
        className
      )}
    >
      {children}
    </div>
  );
};
const ServiceTypePill = ({ type }) => {
  return (
    <div className="flex items-center">
      {type === "PRODUCER" && (
        <Pill className={"text-[#EFD948] ml-[-4px] mr-1"}>P</Pill>
      )}
      {type === "CONSUMER" && (
        <Pill className={"text-[#96EF48] ml-[-4px] mr-1"}>C</Pill>
      )}
      {type === "CONSUMER_PRODUCER" && (
        <>
          <Pill className={"text-[#EFD948] ml-[-4px] mr-1"}>P</Pill>
          <Pill className={"text-[#96EF48] mr-2"}>C</Pill>
        </>
      )}
    </div>
  );
};
export default ServiceTypePill;
